{
  "SEARCH": {
    "TABS": {
      "ALL": "Vše",
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Konverzace",
      "MESSAGES": "Zprávy"
    },
    "SECTION": {
      "CONTACTS": "Kontakty",
      "CONVERSATIONS": "Konverzace",
      "MESSAGES": "Zprávy"
    },
    "VIEW_MORE": "Zobrazit další",
    "LOAD_MORE": "Načíst další",
    "SEARCHING_DATA": "Vyhledávání",
    "LOADING_DATA": "Načítám",
    "EMPTY_STATE": "Nenalezeny žádné {item} pro dotaz '{query}'",
    "EMPTY_STATE_FULL": "Nebyly nalezeny žádné výsledky pro dotaz '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ pro fokus",
    "INPUT_PLACEHOLDER": "Hledat zprávy, kontakty nebo konverzace",
    "RECENT_MESSAGES": "Moje nedávno odeslané zprávy",
    "EMPTY_STATE_DEFAULT": "Vyhledávejte podle ID konverzace, e-mailu, telefonního čísla, zpráv pro lepší výsledky vyhledávání.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Číst více",
    "WROTE": "napsal:",
    "FROM": "od",
    "EMAIL": "e-mailová adresa",
    "EMAIL_SUBJECT": "předmět"
  }
}
